import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth/auth.service';
import { MetadataService } from '../metadata/metadata.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    public authService: AuthService,
    public router: Router,
    private metadata: MetadataService,
  ) {}
  canActivateChild(): Promise<boolean | UrlTree> {
    return this.canActivate();
  }
  canLoad(): Promise<boolean | UrlTree> {
    return this.canActivate();
  }
  async canActivate(): Promise<boolean | UrlTree> {
    // Wait for API Metadata to load
    await this.metadata.waitForMetadataToLoad();
    if (await this.authService.checkAuthenticated()) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
